module.exports = __webpack_public_path__ + "static/media/checklist.05f80c63.png";